import { useCallback } from 'react';

export const useAnimation = () => {
  const animateNumbers = useCallback((element, finalValue, duration = 1000) => {
    if (!element) return;
    
    const startValue = 0;
    const startTime = performance.now();
    
    const animate = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      
      // Easing function for smooth animation
      const easeOut = 1 - Math.pow(1 - progress, 3);
      const currentValue = Math.floor(startValue + (finalValue - startValue) * easeOut);
      
      element.textContent = currentValue;
      
      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        element.textContent = finalValue;
        element.classList.add('animate-number-count');
      }
    };
    
    requestAnimationFrame(animate);
  }, []);

  const createConfetti = useCallback(() => {
    const confettiContainer = document.createElement('div');
    confettiContainer.className = 'confetti-container';
    document.body.appendChild(confettiContainer);
    
    // Create 50 confetti pieces
    for (let i = 0; i < 50; i++) {
      const confettiPiece = document.createElement('div');
      confettiPiece.className = 'confetti-piece';
      confettiPiece.style.left = Math.random() * 100 + '%';
      confettiPiece.style.animationDelay = Math.random() * 3 + 's';
      confettiPiece.style.animationDuration = (Math.random() * 2 + 2) + 's';
      confettiContainer.appendChild(confettiPiece);
    }
    
    // Remove confetti after animation
    setTimeout(() => {
      confettiContainer.remove();
    }, 5000);
  }, []);

  const typewriterEffect = useCallback((setFunction, text, speed = 50) => {
    let displayText = '';
    let i = 0;
    
    const type = () => {
      if (i < text.length) {
        displayText += text.charAt(i);
        setFunction(displayText);
        i++;
        setTimeout(type, speed);
      }
    };
    
    type();
  }, []);

  return { animateNumbers, createConfetti, typewriterEffect };
};